// Messages that can be received from the server
export enum CheckInResponseType {
	SubscribedToCheckIn,
	UpdateBookingStatus,
	BookingCheckedOut,
	BookingAdded,
	BookingUpdated,
	BookingRemoved,
	OnlineBookingStatusChanged,
}
